import axios from "axios";

const createAxiosInstance = (accessToken) => {
  return axios.create({
    baseURL: "https://postalservice-flask-api.vercel.app",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    },
  });
};

export const getFavorites = (sub, accessToken) => {
  return createAxiosInstance(accessToken).get(`/favorites`, {
    params: { sub },
  });
};

export const addFavorite = (sub, item, accessToken) => {
  return createAxiosInstance(accessToken).post(`/favorites`, { sub, item });
};

export const removeFavorite = (sub, itemId, accessToken) => {
  return createAxiosInstance(accessToken).delete(`/favorites`, {
    data: { sub, itemId },
  });
};
